export default __webpack_public_path__ + "static/media/medium.74e98b25.svg";